var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('transition',{attrs:{"name":"fadeHome"}},[_c('bar-carousel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }